import { NgZone } from '@angular/core';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { fromEvent, merge, timer, Subject } from 'rxjs';
import { mapTo, switchMap, startWith, takeUntil } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

const SESSION_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes

@Injectable({ providedIn: 'root' })
export class IdleTimeoutService {
  private stop$ = new Subject<void>();
  private activitySub?: Subscription;
  private running = false;

  constructor(private msal: MsalService, private zone: NgZone) {}

  public start(): void {
    if (this.running) {
      return;
    }
    this.running = true;

    this.zone.runOutsideAngular(() => {
      const activity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'click'),
        fromEvent(window, 'scroll'),
        fromEvent(window, 'focus')
      ).pipe(mapTo(true));

      this.activitySub = activity$
        .pipe(
          startWith(true),
          switchMap(() => timer(SESSION_TIMEOUT_MS)),
          takeUntil(this.stop$)
        )
        .subscribe(() => {
          this.zone.run(() => {
            this.msal.logoutRedirect({ postLogoutRedirectUri: environment.azureAd.posLogoutUrl });
          });
        });
    });
  }

  public stop(): void {
    // Stop the active subscription and mark as not running so start() can be called again
    if (this.activitySub) {
      this.activitySub.unsubscribe();
      this.activitySub = undefined;
    }
    this.running = false;
    this.stop$.next();
  }
}